export function adaptValue(value) {
  let removeSign = String(value).replace(/[R$]/gm, '').trim()
  removeSign = removeSign.replace(/[%]/gm, '').trim()
  removeSign = removeSign.replace(/\s/gm, '').trim()

  let removeDot = removeSign

  if (/[,]/gm.test(value)) {
    removeDot = removeSign.replace(/[.]/gm, '').trim()
  }

  const valueFormatted = removeDot.replace(/[,]/gm, '.').trim()

  return Number(Number(valueFormatted).toFixed(2))
}
